import {
  getLocalUser,
  hasManagerAccessToPath,
} from "@/constants/managerAccess";

const staffPermissionsMap = {
  "/authentication/logout": true,
  "/team/editprofile": true,
  "/ecommerce/calendar": true,
  "/clients": true,
  "/service-orders": true,
};

const allowed = (path) => {
  if (!path) {
    return false;
  }

  const user = getLocalUser();
  if (!user) {
    return false;
  }

  const rolesMap = user.rolesMap;
  if (!rolesMap) {
    return true;
  }

  const isOnlyStaff =
    !rolesMap.isRoot &&
    !rolesMap.isOwner &&
    !rolesMap.isManager &&
    rolesMap.isStaff;
  if (isOnlyStaff) {
    return !!staffPermissionsMap[path];
  }

  return hasManagerAccessToPath(path, user);
};

export default allowed;
